import { GetterTree } from 'vuex';
import { IRootState } from '@/store/types';
import { IPayoutState } from './types';

export const getters: GetterTree<IPayoutState, IRootState> = {
    GET_ALL_AFFILIATES_METHODS: (state) => state.allAffiliatesMethods,
};
